import { Serie } from "react-charts";
import { normalizeDateItems } from "simple-utils/dist/date-utils";
import { DailyReport } from "../../models/FullReportEntry";

export function buildSeries(dailyReports:DailyReport[], pastReports:DailyReport[], field: keyof DailyReport, style = "color1"){
    var data = dailyReports.map(a => {
        return {
            date: a.date,
            x: a.date.getDate(),
            y: a[field]
        }
    });

    var past = pastReports ? pastReports.map(a => {
        return {
            date: a.date,
            x: a.date.getDate(),
            y: a[field]
        }
    }) : [];

    data = normalizeDateItems(data, i => i.date, date => ({date, x: date.getDate(), y: 0}));
    past = normalizeDateItems(past, i => i.date, date => ({date, x: date.getDate(), y: 0}));

    return ([{
        style: style,
        data,
        label: "Este mês"
    },
    {
        style: "color10",
        lineStyle: "dashed",
        data: past,
        label: "Mês Passado"
    }] as Serie[]).filter(a => a.data.length > 0);
}